import Config from '@/config'

import Logger, { initializeLogger } from './core'

export default {
  async install(Vue) {
    Vue.prototype.$logger = Logger
    initializeLogger()
  },
}

if (Config.isDev) {
  window.logger = Logger
}
